import React from 'react'
import PropTypes from 'prop-types'
import BarChart from './BarChart'
import BarChartUnlimited from './BarChartUnlimited'
import { mapTidyUsageNames } from '../constants'
import BarChartText from './BarChartText'

class UsageCurrent extends React.Component {
    getElement () {
        return this.container
    }

    isUnlimited (item) {
        return ((item.total === 0 || item.total === '0' || item.total === '' || !item.total) && item.type !== 'date')
    }

    isText (item) {
	    return item.type === 'text'
    }

    filterTitle (item) {
        if (mapTidyUsageNames[item.title]) {
            item.title = mapTidyUsageNames[item.title]
        }
    }

    render () {
        const text = []
        const unlimited = []
        const barObjects = []

        this.props.usage.forEach((item, key) => {
		    this.filterTitle(item)
		    if (this.isText(item)) {
                text.push(<BarChartText key={key} item={item} />)
            } else if (this.isUnlimited(item)) {
                unlimited.push(<BarChartUnlimited key={key} item={item} isUnlimited={this.props.isUnlimitedUsage} />)
            } else {
                barObjects.push(<BarChart key={key} data={item} isDataBank={item.title === 'Data Bank'} isUnlimited={this.props.isUnlimitedUsage} />)
            }
        })

        return (
            <div className='usage-current' ref={el => this.container = el}>
                {barObjects.map(item => item)}
                {text.map(item => item)}
                {unlimited.map(item => item)}
            </div>
        )
    }
}

UsageCurrent.propTypes = {
    usage: PropTypes.array.isRequired,
    isUnlimitedUsage: PropTypes.bool
}

export default UsageCurrent



// WEBPACK FOOTER //
// ./resources/js/components/UsageCurrent.js